import BaseModelRequest from '../communicate/BaseModelRequest'
import {getToken} from '../services/authService'
import ApiConfig from '../communicate/ApiConfig'

export default class OrderHistoryRequest extends BaseModelRequest{

  builderHeader () {
    const headers = super.builderHeader();
    headers.Authorization = 'Bearer ' + getToken();

    return headers;
  }

  loadHistory(page, pageSize) {
    const url = `order-item/history?page=${page}&size=${pageSize}`;
    return this.get(url);
  }

  getOrderHistory(data) {
    const url = `order-item/history?page=${data.page}&limit=${data.limit}`;
    return this.get(url);
  }

  getOrderDetail(id, type) {
    const url = `order-item/history/${id}/${type}`;
    return this.get(url);
  }

  getLaso() {
    const url = `laso`;
    return this.get(url);
  }

  getCaiVan() {
    const url = `cai-van/history`;
    return this.get(url, '', ApiConfig.v2);
  }
}



// WEBPACK FOOTER //
// ./src/request/OrderHistoryRequest.js